import { useMemo } from 'react';
import { useKeycloak } from '../components/KeycloakProvider';
import { createApiClient, ApiClient } from '../api';

/**
 * Hook that creates and manages an API client with Keycloak token refresh capability.
 * Returns a memoized API client that automatically handles token refresh on 401 errors.
 */
export const useApiClient = (): ApiClient => {
  const { keycloak } = useKeycloak();

  const apiClient = useMemo(() => {
    return createApiClient({
      getToken: async () => {
        if (!keycloak?.authenticated) {
          return undefined;
        }
        try {
          await keycloak.updateToken(60);
          return keycloak.token;
        } catch {
          keycloak.login();
          return undefined;
        }
      },
    });
  }, [keycloak]);

  return apiClient;
};
